import Cookies from "js-cookie";
const MyLocalStorage = {
  USER_INFO_KEY: "user_info",
  ACCESS_TOKEN_KEY: "access_token",

  setUserInfo(user_info) {
    Cookies.set(this.USER_INFO_KEY, user_info);
  },
  getUserInfo() {
    return Cookies.getJSON(this.USER_INFO_KEY);
  },
  removeUserInfo() {
    return Cookies.remove(this.USER_INFO_KEY);
  },
  setAccessToken(access_token, expire) {
    Cookies.set(this.ACCESS_TOKEN_KEY, access_token, {
      expires: expire / (60 * 60 * 24)
    });
  },
  getAccessToken() {
    return Cookies.get(this.ACCESS_TOKEN_KEY);
  },
  removeAccessToken() {
    return Cookies.remove(this.ACCESS_TOKEN_KEY);
  }
};

export default MyLocalStorage;
